import { VStack, XText, XVPScroll } from "IZOX/_X";
import { Accessor, ColorX, LocaleX, ZMath } from "IZOX/STATIC";
import { useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";

function OptionList({
  rect,
  popupRound,
  popupPosition,
  listFontSize,
  multiple,
  searchValue,
  posStyle,
  bgColor,
  listMaxHeight,
  options,
  valAccessor,
  disableAccessor,
  _renderOption,
  _value,
  _newForm,
  onEnterKeyDown,
  onEscapeKeyDown,
  ctrls
}){

  const [highlightedIdx, setHighlightedIdx] = useState(-1);
  const [disValue, setDisValue] = useState(_value);
  const ref = useRef(null);

  useImperativeHandle(ctrls, () => ({
    setValue: (value) => {
      setDisValue(value);
    }
  }), []);

  const _setHighlightedIdx = useCallback((shift) => {
    let newIdx = ZMath.Cap(highlightedIdx + shift, 0, (options?.length ?? 1) - 1);
    setHighlightedIdx(newIdx);
    ref.current?.scrollToIndex(newIdx);
  }, [options, highlightedIdx, setHighlightedIdx]);

  const onKeyDown = useCallback((e) => {
    if(e.key === "ArrowDown"){
      e.preventDefault();
      _setHighlightedIdx(1);
    }else if(e.key === "ArrowUp"){
      e.preventDefault();
      _setHighlightedIdx(-1);
    }else if(e.key === "Enter"){
      e.preventDefault();
      let option = options?.[highlightedIdx];
      if(!option) return;
      let _disabled = Accessor.Get(option, disableAccessor) ?? false;
      if(_disabled) return;
      onEnterKeyDown?.(option, _newForm);
    }else if(e.key === "Escape"){
      e.preventDefault();
      onEscapeKeyDown?.();
    }
  }, [_setHighlightedIdx, onEnterKeyDown, onEscapeKeyDown, options, highlightedIdx, _newForm, disableAccessor]);

  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [onKeyDown]);

  const onMountedVP = useCallback((callbacks) => {
    ref.current = callbacks;
  }, []);

  if(options?.length === 0){
    return (
      <VStack position="absolute" round={popupRound} width={rect?.width ?? 0}
        style={posStyle} bgColor={ColorX.CSS("pureWhite")} shadow pV={5}>
        <XText fontSize={listFontSize} italic color={ColorX.CSS("placeholder")}>
          {LocaleX.Parse({EN: "No Options", TC: "沒有選項"})}
        </XText>
      </VStack>
    );
  }
  return (
    <VStack position="absolute" round={popupRound} 
      style={posStyle} bgColor={bgColor} shadow>
        <XVPScroll width={rect?.width ?? 0} round={popupRound} onMounted={onMountedVP}
          bW={1} bColor={ColorX.CSS("lightGrey")} masked
          bgColor={ColorX.CSS("pureWhite")}
          justifyContent={popupPosition === "bottom" ? "flex-start" : "flex-end"}
          style={{maxHeight: listMaxHeight}} items={options}>
            {(o, i) => {
              let isHighlighted = highlightedIdx === i;
              let isSelected = multiple ?
              disValue?.includes?.(Accessor.Get(o, valAccessor))
              : Accessor.Get(o, valAccessor) === disValue;
              return _renderOption?.(o, isSelected, searchValue, _newForm, isHighlighted);
            }}
        </XVPScroll>
    </VStack>
  );  

}

export default OptionList;